import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Detectar se estamos a correr dentro da app nativa (Capacitor / Android WebView).
// Permite aplicar safe-area-insets e ajustar UI para o ecrã do telemóvel.
(function detectNativeApp() {
  try {
    const ua = (navigator.userAgent || "").toLowerCase();
    const isCapacitor = !!(window.Capacitor || window.cordova);
    const isAndroidWebView = /; wv\)/.test(ua) || /version\/[\d.]+\s+chrome\/[\d.]+\s+mobile/.test(ua);
    const isStandalonePWA = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    if (isCapacitor || isAndroidWebView || isStandalonePWA) {
      document.body.classList.add("is-native-app");
      document.documentElement.classList.add("is-native-app");
    }
  } catch (_) { /* ignore */ }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
